import React from "react";
import SatisfactionMapProvider from "../../contexts/SatisfactionMapFilterContext"; 
import Breadcrumb from "../../components/Breadcrumbs";
import SatisfactionFilters from "./SatisfactionFilters";
import SatisfactionMap from "./SatisfactionMap";
import MapLegend from '../../components/MapLegend';

const MapaSatisfacao = () => {
  return (
    <div className="map-container">
      <Breadcrumb 
        paths={[
          { href: "/", name: "Mapa" },
          { href: "/", name: "Mapa de Satisfação" },
        ]}
      />
      <SatisfactionMapProvider> 
        <div style={{borderRadius: "17px", backgroundColor: "#F5F5F5", position: 'relative'}}>
          <SatisfactionFilters/>
          <SatisfactionMap/>
          <MapLegend/> 
        </div>
      </SatisfactionMapProvider>
    </div>
  )
};

export default MapaSatisfacao;
